import { QueryResult, useQuery } from '@apollo/client'
import {
  Country,
  PyramidForecastValuesQuery,
  PyramidForecastValuesQueryVariables,
  PyramidForecastWithFiltersQuery,
  PyramidForecastWithFiltersQueryVariables,
} from '../../../types'
import { PYRAMID_FORECAST_VALUES, PYRAMID_FORECAST_WITH_FILTERS } from '../Queries'

export const usePyramidForecast = (
  companyId: string,
  country: Country,
): QueryResult<PyramidForecastWithFiltersQuery, PyramidForecastWithFiltersQueryVariables> => {
  return useQuery<PyramidForecastWithFiltersQuery, PyramidForecastWithFiltersQueryVariables>(PYRAMID_FORECAST_WITH_FILTERS, {
    variables: {
      companyId,
      country,
    },
    fetchPolicy: 'network-only',
  })
}

export const usePyramidForecastValues = (
  companyId: string,
  country: Country,
  year: number,
  month: number,
): QueryResult<PyramidForecastValuesQuery, PyramidForecastValuesQueryVariables> => {
  return useQuery<PyramidForecastValuesQuery, PyramidForecastValuesQueryVariables>(PYRAMID_FORECAST_VALUES, {
    variables: { companyId, country, year, month },
    fetchPolicy: 'network-only',
  })
}
